import axios from 'axios';
import { post, get, put, deleteApi } from './axiosFun';

// 登录接口
export const login = (params) => { return post("/sys/auth/pcLogin", params) };
export const verifyCode = () => { return get("/sys/auth/verifyCode") };
// 退出接口
export const loginout = () => { return post("/sys/auth/loginOut", {}) };


// 用户分页
export const userPage = (params) => { return post("/sys/sys-user/userPage", params) };
// 用户列表
export const userList = (params) => { return post("/sys/sys-user/userList", params) };
// 用户新增
export const userAdd = (params) => { return post("/sys/sys-user/userAdd", params) };
// 用户编辑
export const userEdit = (params) => { return post("/sys/sys-user/userEdit", params) };
//用户删除
export const userRemove = (params) => { return post("/sys/sys-user/userRemove", params) };
//用户启用|禁用
export const userEnableOrDisable = (params) => { return post("/sys/sys-user/userEnableOrDisable", params) };
// 用户导入
export const userImport = (params) => { return post("/sys/sys-user/userImport", params) };

// 用户导入查询结果
export const userImportRes = () => { return get("/sys/sys-user/userImportRes") };

// 用户修改初始密码
export const userSetPsw = (params) => { return post("/sys/auth/userSetPsw", params) };

// 用户修改密码
export const userEditPsw = (params) => { return post("/sys/auth/userEditPsw", params) };
// 重置用户密码
export const remakePasswd = (params) => { return post("/sys/sys-user/remakePasswd", params) };


// 基本信息
export const baseInfo = () => { return get("/sys/personal/baseInfo") };

// 改头像
export const editAvatar = (params) => { return post("/sys/personal/editAvatar", params) };




// 图形监督设置
export const configAdd =(params)=>{return post("/sys/sys-config/configAdd",params)}
export const configAddOrEdit =(params)=>{return post("/sys/sys-config/configAddOrEdit",params)}
export const configList = () => { return get("/sys/sys-config/configList") };


// WEBPACK FOOTER //
// ./src/api/userMG.js